import "./Industries.module.css";
import MainHeader from "@/reusable_sections/Header";
import HomeProfessionalServices from "./sections/HomeProfessionalServices";
import RealEstateHealthcare from "./sections/RealEstateHealthcare";
import FinanceRetail from "./sections/FinanceRetail";
import Footer from "@/reusable_sections/Footer";
export default function IndustriesPage() {
  return <div>
      <MainHeader />
      <HomeProfessionalServices />
      <RealEstateHealthcare />
      <FinanceRetail />
      <Footer />
    </div>;
}